module.exports = __webpack_public_path__ + "h5/img/qukuan.00a8f669.png";